import React, { CSSProperties, useCallback, useEffect, useRef, useState } from "react";
import styles from "./toast.module.scss";
import classnames from "classnames";
import type { IModalInstance } from "@whatslly/ui-components/modals";

const ANIMATION_STATUS = {
  START_ANIMATION: "startAnimation",
  STOP_ANIMATION: "stopAnimation",
};

export interface ToastProps {
  text: React.ReactNode;
  className?: string;
  animation?: "startAnimation" | "stopAnimation";
  timeout?: number;
  style?: CSSProperties;
  darkMode?: boolean;
  type?: "regular" | "error";
}

const Toast: React.FC<ToastProps & IModalInstance<never>> = ({ text = "Triggred", timeout, closeModal, animation, className, style, type }) => {
  const [animationStatus, setAnimationStatus] = useState(animation || ANIMATION_STATUS.START_ANIMATION);
  const toastRef = useRef<HTMLDivElement>(null);
  const toastContainerRef = useRef<HTMLDivElement>(null);

  const handleForceClose = useCallback(() => {
    setAnimationStatus(ANIMATION_STATUS.STOP_ANIMATION);
    setTimeout(() => closeModal(), 1000);
  }, [closeModal]);

  useEffect(() => {
    setTimeout(() => handleForceClose(), timeout || 5000);
  }, [timeout, handleForceClose]);

  useEffect(() => {
    if (toastRef.current && toastContainerRef.current) {
      toastContainerRef.current.style.height = `${toastRef.current.scrollHeight}px`;
    }
  }, []);

  return (
    <div className={classnames(styles.toastContainer, styles[animationStatus])} ref={toastContainerRef} data-testid={"toast"}>
      <div className={classnames(styles.toast, styles[animationStatus], className, [styles[type ?? "regular"]])} style={style} ref={toastRef}>
        <span>{text}</span>
        <button className={styles.xButton} onClick={handleForceClose} data-testid={"toast-close"}>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="white" />
          </svg>
        </button>
      </div>
    </div>
  );
};
export default Toast;
